import React, { Component } from 'react';
import { Link } from "react-router-dom";
import { CardBody, Card, CardHeader, CardFooter, Label, Button, CardText, Row, Col } from 'reactstrap';
import { Pagination, PaginationItem, PaginationLink, Input } from 'reactstrap';
import Image from 'react-bootstrap/Image';
import Paginacion from './Paginacion';
import { withRouter } from 'react-router-dom';
import PropTypes from 'prop-types';
import Select from 'react-select';
import { bindNodeCallback } from 'rxjs';

function importAll(r) {
    let images = {};
    r.keys().forEach((item, index) => { images[item.replace('./', '')] = r(item); });
    return images
}

const options = [
    { value: '0', label: 'Todos' },
    { value: '1', label: 'Atendidas' },
    { value: '2', label: 'Parcialmente Atendidas' },
    { value: '3', label: 'Pendientes' }
]

const optionsDelegacion = [
    { value: '0', label: 'Todos' },
    { value: '1', label: 'Delegados' },
    { value: '2', label: 'No delegados' }
]

const images = importAll(require.context('./icons', false, /\.(jpg|png|jpe?g|svg)$/));

const imgStyle = {
    maxHeight: 50,
    maxWidth: 50
}

//cantidad a items a renderizar en paginación
/*const limite = 6;*/
const vecindario = 1;
let optPagina = { "pageLimit": 6, "totalRecords": 0, "currentPage": 1, "totalPages": 0 }

class LoteCarga extends Component {
    static displayName = LoteCarga.name;

    constructor(props) {
        super(props);
        const cargaList = this.props.carga;
        this.state = {
            actividades: cargaList,
            actividadesMutar: cargaList,
            currentActividades: [],
            currentPage: 1,
            totalPages: null,
            delegacionSelect: 'Todos',
            tipoSelect: 'Todos',
            filterDelegacion: 0,
            filterTipo: 0,
            rol: this.props.rol,
            totalPageP: Math.ceil(cargaList.length / 9),
            actualPage: 1,
            limite: 9,
            siblingCount: 1,
        };
        this.page = this.page.bind(this);
        this.onChangeLimite = this.onChangeLimite.bind(this);
    }

    componentDidMount() {
        /*console.log("MONTADOOOO", this.props.location.state)*/
        if (this.props.location.state !== undefined) {
            const locationState = this.props.location.state;
            const labelTipo = options.find(x => parseInt(x.value) === locationState.type).label
            const labelDelegacion = optionsDelegacion.find(x => parseInt(x.value) === locationState.delegation).label
            //console.log(locationState.type)
            this.setState({ filterTipo: locationState.type, tipoSelect: labelTipo }, function () {
                this.handleChangeDelegacion({ value: locationState.delegation, label: labelDelegacion })
            });

        }
        /*console.log('user', this.state.actividades);*/
    }

    handleChangeTipo = selectedOption => {
        //console.log(`Option selected:`, selectedOption);

        const value = parseInt(selectedOption.value);
        this.setState({ filterTipo: value, tipoSelect: selectedOption.label });
        const { filterDelegacion } = this.state;
        let mapeo = this.state.actividades;
        //console.log("MAPEO", mapeo);
        if (filterDelegacion === 1) {
            mapeo = mapeo.filter(x => x.cantAccionesCoor > 0)
            if (value === 1) {
                mapeo = mapeo.filter(x => x.cantAccionesCoor == x.accionesIngresadasCoor);
            }
            else if (value === 3) {
                mapeo = mapeo.filter(x => x.accionesIngresadasCoor === 0 && x.cantAccionesCoor !== 0);
            }
            else if (value === 2) {
                mapeo = mapeo.filter(x => x.cantAccionesCoor > 1 && x.accionesIngresadasCoor >= 1);
            }
        }
        else if (filterDelegacion === 2) {
            if (filterDelegacion === 2)
                mapeo = mapeo.filter(x => x.cantAccionesCoor === 0)
            if (value === 1) {
                mapeo = mapeo.filter(x => (x.cantAcciones) == x.accionesIngresadas);
            }
            else if (value === 3) {
                mapeo = mapeo.filter(x => x.accionesIngresadas === 0 && x.cantAcciones !== 0);
            }
            else if (value === 2) {
                mapeo = mapeo.filter(x => x.cantAcciones > 1 && x.accionesIngresadas >= 1);
            }
        } else if (filterDelegacion === 0) {
            if (value === 1) {
                mapeo = mapeo.filter(x => x.cantAcciones + x.cantAccionesCoor == x.accionesIngresadas + x.accionesIngresadasCoor && x.cantAcciones > 0);
            }
            else if (value === 3) {
                mapeo = mapeo.filter(x => x.accionesIngresadas + x.accionesIngresadasCoor === 0 && x.cantAcciones + x.cantAccionesCoor !== 0);
            }
            else if (value === 2) {
                mapeo = mapeo.filter(x => x.cantAcciones + x.cantAccionesCoor > 1 && x.accionesIngresadas + x.accionesIngresadasCoor >= 1 && x.cantAcciones + x.cantAccionesCoor > x.accionesIngresadas + x.accionesIngresadasCoor);
            }
        }
        
        //console.log("MAPEO", mapeo);
        //const currentActividades = mapeo.slice(0, 0 + limite);
        //console.log(currentActividades);
        //this.setState({ currentActividades: currentActividades, totalRecords: currentActividades.length, actividadesMutar: mapeo });
        this.setState({ actividadesMutar: mapeo, actualPage: 1 });
        this.reLoadTotalPage(mapeo.length, this.state.limite);
    };

    handleChangeNombre = selectedOption => {
        const { value, label } = selectedOption;
        let mapeo = []
        if (value === 0) {
            //console.log("ENTRO 0")
            //reseteo
            this.handleChangeTipo({ label: "Todos", value: this.state.filterTipo });
        } else {
            mapeo = this.state.actividades.filter(x => x.intIdPersona === value);
            //const currentActividades = mapeo.slice(0, 0 + 6);
            //this.setState({ currentActividades: currentActividades, totalRecords: currentActividades.length, actividadesMutar: mapeo });
            this.setState({ actividadesMutar: mapeo, actualPage: 1});
            this.reLoadTotalPage(mapeo.length, this.state.limite);
        }

    };

    handleChangeDelegacion = selectedOption => {
        //console.log(`Option selected:`, selectedOption);

        const value = parseInt(selectedOption.value);
        this.setState({ filterDelegacion: value, delegacionSelect: selectedOption.label });
        const { filterTipo } = this.state;
        let mapeo = this.state.actividades;
        if (value === 1) {
            mapeo = mapeo.filter(x => x.cantAccionesCoor > 0)
            if (filterTipo === 1) {
                mapeo = mapeo.filter(x => x.cantAccionesCoor == x.accionesIngresadasCoor);
            }
            else if (filterTipo === 3) {
                mapeo = mapeo.filter(x => x.accionesIngresadasCoor === 0 && x.cantAccionesCoor !== 0);
            }
            else if (filterTipo === 2) {
                mapeo = mapeo.filter(x => x.cantAccionesCoor > 1 && x.accionesIngresadasCoor >= 1);
            }
        }
        else if (value === 2 || value === 0) {
            if (value === 2)
                mapeo = mapeo.filter(x => x.cantAccionesCoor === 0)
            if (filterTipo === 1) {
                mapeo = mapeo.filter(x => x.cantAcciones == x.accionesIngresadas);
            }
            else if (filterTipo === 3) {
                mapeo = mapeo.filter(x => x.accionesIngresadas === 0 && x.cantAcciones !== 0);
            }
            else if (filterTipo === 2) {
                mapeo = mapeo.filter(x => x.cantAcciones > 1 && x.accionesIngresadas >= 1 && x.cantAcciones > x.accionesIngresadas);
            }
        }
        //console.log("FILTER TIPO: ", filterTipo)
        //console.log("MAPEO POS FILTER TIPO: ", mapeo)
        //const currentActividades = mapeo.slice(0, 0 + limite);
        //console.log(currentActividades);
        //this.setState({ currentActividades: currentActividades, totalRecords: currentActividades.length, actividadesMutar: mapeo });
        this.setState({ actividadesMutar: mapeo, actualPage: 1});
        this.reLoadTotalPage(mapeo.length, this.state.limite);
    };

    onPageChanged = data => {
        const { actividadesMutar } = this.state;
        const { currentPage, totalPages, pageLimit } = data;
        const offset = (currentPage - 1) * pageLimit;
        //console.log(data)
        //console.log(actividadesMutar)
        const currentActividades = actividadesMutar.slice(offset, offset + pageLimit);

        this.setState({ currentPage: currentPage, currentActividades });
        //console.log(currentActividades);
        //console.log(currentPage);
    }

    returnStatus = act => {
        return (act.accionesIngresadas + act.accionesIngresadasCoor === 0 || this.state.filterTipo === 3) ? "pe" :
                (act.accionesIngresadas + act.accionesIngresadasCoor == act.cantAcciones + act.cantAccionesCoor || this.state.filterTipo === 1) ? "at" : "pa"
    }

    redirect = idPersona =>{
        //console.log('alola')
        this.props.history.push('/profesor/'+idPersona)
    }

    page(num) {
        if (this.state.actualPage !== num) {
            this.setState({
                actualPage: num
            });
        }
    }

    pagePrevious() {
        if (this.state.actualPage !== 1) {
            let p = this.state.actualPage;
            this.setState({
                actualPage: p - 1
            });
        }
    }

    pageNext() {
        if (this.state.actualPage !== this.state.totalPageP) {
            let p = this.state.actualPage;
            this.setState({
                actualPage: p + 1
            });
        }
    }

    youAreMySibling(num) {
        let actualPage = this.state.actualPage;
        let sibling = this.state.siblingCount;
        let total = this.state.totalPageP;
        let valor = false;
        if (num === actualPage || num - sibling === actualPage || num + sibling === actualPage) {
            valor = true;
        }
        if (actualPage === 1 && (num - 1 === actualPage || num - 2 === actualPage || num - 3 === actualPage)) {
            valor = true;
        }
        if (actualPage === 2 && (num - 1 === actualPage || num - 2 === actualPage)) {
            valor = true;
        }
        if (actualPage === total && (num + 1 === actualPage || num + 2 === actualPage || num + 3 === actualPage)) {
            valor = true;
        }
        if (actualPage === total - 1 && (num + 1 === actualPage || num + 2 === actualPage)) {
            valor = true;
        }
        //console.log(num, valor);
        return valor;
    }

    reLoadTotalPage(lenActividades, limite) {
        this.setState({ totalPageP: Math.ceil(lenActividades / limite) });
        /*console.log('Total Paginas: ',this.state.totalPageA);*/
    }

    onChangeLimite(event) {
        //console.log('Cambio limite');
        //console.log(event.target.value);
        var num = event.target.value;
        this.setState({ limite: num, actualPage: 1 });
        this.reLoadTotalPage(this.state.actividadesMutar.length, num);
    }

    render() {
        const {
            currentActividades, currentPage,
            actividadesMutar, filterTipo
        } = this.state;

        let nombresText = actividadesMutar === null || Object.keys(actividadesMutar).length === 0 ? [] : actividadesMutar.map(x => ({ label: x.strNombreCompleto, value: x.intIdPersona }));
        /*console.log(filterTipo)*/
        if(filterTipo === 0 ){
            /*console.log("OG",currentActividades)*/
            currentActividades.sort((a,b) => {
                if(a.strEstado > b.strEstado) { return -1; }
                if(a.strEstado < b.strEstado) { return 1; }
            })
            //console.log("UPDATED",currentActividades)
        }

        let pagesA = [];
        for (let i = 1; i <= this.state.totalPageP; i++) {
            pagesA.push(<></>);
        }

        /*console.log(nombresText)*/
        nombresText.push({ label: "Ninguna", value: 0 });

        return (
            <div>
                <Row>
                    <Col xs="4">
                        <label>
                            Nombre/Apellido:
                        </label>
                        <Select name="nombre"
                            options={nombresText}
                            value={this.state.nombre}
                            onChange={this.handleChangeNombre} />
                    </Col>
                    <Col xs="4">
                        <label>
                            Tipo:
                        </label>
                        <Select options={options}
                            value={{ label: this.state.tipoSelect, value: this.state.filterTipo }}
                            onChange={this.handleChangeTipo} />
                            
                    </Col>
                    <Col xs="4">
                        {this.state.rol.includes('SUBDECANO') ?
                        <>
                        <label>
                            Delegación:
                        </label>
                        <Select options={optionsDelegacion}
                            value={{ label: this.state.delegacionSelect, value: this.state.filterDelegacion }}
                                onChange={this.handleChangeDelegacion} />
                        </>
                        : <></>}
                    </Col>
                </Row>
                <div className="container mb-5">
                    <div className="row d-flex flex-row">
                    <div className="d-flex flex-row align-items-center col-9">
                            <h3>
                                <label style={{ color: '#918AD3' }} ></label>
                            </h3>
                        </div>{/* 918AD3 */}                          
                        <Row hidden={actividadesMutar.length === 0}>
                            <Col xs="8">
                                    
                            </Col>                            
                                <Col>
                                <Pagination hidden={pagesA.length < 1} id={'newPagination'}>
                                        <PaginationItem active={this.state.actualPage === 1} onClick={() => { this.page(1); }}>
                                            <PaginationLink>
                                                {1}
                                            </PaginationLink>
                                        </PaginationItem>
                                        <PaginationItem hidden={this.state.totalPageP < 5 || this.state.actualPage === 1} onClick={() => { this.pagePrevious(); }}>
                                            <PaginationLink previous />
                                        </PaginationItem>
                                        {pagesA.map((page, i) =>
                                        (
                                            <PaginationItem hidden={i + 1 === 1 || i + 1 === this.state.totalPageP || !this.youAreMySibling(i + 1)} active={this.state.actualPage === i + 1} onClick={() => { this.page(i + 1); }}>
                                                <PaginationLink>
                                                    {i + 1}
                                                </PaginationLink>
                                            </PaginationItem>)
                                        )}
                                        <PaginationItem hidden={this.state.totalPageP < 5 || this.state.actualPage === this.state.totalPageP} onClick={() => { this.pageNext(); }}>
                                            <PaginationLink next />
                                        </PaginationItem>
                                        <PaginationItem hidden={this.state.totalPageP === 1} active={this.state.actualPage === this.state.totalPageP} onClick={() => { this.page(this.state.totalPageP); }}>
                                            <PaginationLink>
                                                {this.state.totalPageP}
                                            </PaginationLink>
                                        </PaginationItem>
                                    </Pagination>
                                </Col>
                            <Col xs="1">
                                <Input className="col-md-6" style={{ width: '5vw' }} type="select" onChange={this.onChangeLimite} value={this.state.limite} >
                                    <option hidden key={"sel-3"} selected={3 == this.state.limite} value={3}>{3}</option>
                                    <option key={"sel-6"} selected={6 == this.state.limite} value={6}>{6}</option>
                                    <option key={"sel-9"} selected={9 == this.state.limite} value={9}>{9}</option>
                                    <option key={"sel-12"} selected={12 == this.state.limite} value={12}>{12}</option>
                                </Input>
                            </Col>
                            </Row>
                        {actividadesMutar.map((act,i) =>
                            <div className="col-4 py-2" hidden={!(this.state.actualPage === Math.ceil((i + 1) / this.state.limite))}>
                                <Card style={{ height: '100%' }} onClick={() => this.redirect(act.intIdPersona)}>
                                
                                    <CardHeader style={{ backgroundColor: '#ECEFF3', display: 'flex' }}>
                                        <Row>

                                            <Col className='col-3 px-1'>
                                                <Image src={"https://talentohumano.espol.edu.ec/imgEmpleado/" + act.strCedula + ".jpg"}
                                                    onError={(e) => (e.target.onerror = null, e.target.src = images['user2.png'].default)}
                                                    style={{ width: 60, height: 60, borderRadius: '50%', overflow: 'hidden', borderWidth: 3, borderColor: 'red', }} />
                                            </Col>

                                            <Col className='col-9 px-2 py-2'>
                                                <Label style={{ justifyContent: 'center', fontSize: "1.9vh" }}><strong>{act.strNombreCompleto}</strong></Label>
                                            </Col>

                                        </Row>
                                    </CardHeader>
                                    <CardBody>
                                        <CardText>Observaciones Totales: <strong>{act.cantAcciones + act.cantAccionesCoor}</strong></CardText>
                                        <CardText>Observaciones Atendidas: <strong>{act.accionesIngresadas}</strong></CardText>
                                        {/* <CardText>accionesPorIngresar: <strong>{act.accionesPorIngresar}</strong></CardText> */}
                                        {this.state.rol.includes('SUBDECANO') ? <CardText>Observaciones Delegadas: <strong>{act.cantAccionesCoor}</strong></CardText> : <></>}
                                        {this.state.rol.includes('SUBDECANO') ? <CardText>Delegaciones Atendidas: <strong>{act.accionesIngresadasCoor}</strong></CardText> : <></>}                                                                                
                                    </CardBody>
                                    <CardFooter>
                                        <Row>
                                            <Col className={"alola " + this.returnStatus(act)} >
                                                <CardText>Estado: <strong>{this.state.filterTipo === 0 ?
                                                    act.accionesIngresadas + act.accionesIngresadasCoor === 0 ? "Pendiente" :
                                                        act.accionesIngresadas + act.accionesIngresadasCoor == act.cantAcciones + act.cantAccionesCoor ? "Atendido" : "Parcialmente Atendido"
                                                    : this.state.tipoSelect}</strong></CardText>
                                            </Col>
                                            <Col className="col-2">
                                                <Link
                                                    to={`/profesor/${act.intIdPersona}`}
                                                    key={act.intIdPersona}
                                                >
                                                    <img src={images['edit.png'].default} alt="edit" width="30px" height="30px" className="iconEdit" />
                                                </Link>
                                            </Col>
                                        </Row>
                                    </CardFooter>
                                    
                                </Card>
                                
                            </div>
                        )}
                        {actividadesMutar.length === 0 ?
                            <Card className='py-2'>No hubo resultados</Card>
                            : <></>}
                        <Row hidden={actividadesMutar.length === 0}>
                            <Col xs="8">
                            </Col>                            
                            <Col>
                                <Pagination hidden={pagesA.length < 1} id={'newPagination'}>
                                    <PaginationItem active={this.state.actualPage === 1} onClick={() => { this.page(1); }}>
                                        <PaginationLink>
                                            {1}
                                        </PaginationLink>
                                    </PaginationItem>
                                    <PaginationItem hidden={this.state.totalPageP < 5 || this.state.actualPage === 1} onClick={() => { this.pagePrevious(); }}>
                                        <PaginationLink previous />
                                    </PaginationItem>
                                    {pagesA.map((page, i) =>
                                    (
                                        <PaginationItem hidden={i + 1 === 1 || i + 1 === this.state.totalPageP || !this.youAreMySibling(i + 1)} active={this.state.actualPage === i + 1} onClick={() => { this.page(i + 1); }}>
                                            <PaginationLink>
                                                {i + 1}
                                            </PaginationLink>
                                        </PaginationItem>)
                                    )}
                                    <PaginationItem hidden={this.state.totalPageP < 5 || this.state.actualPage === this.state.totalPageP} onClick={() => { this.pageNext(); }}>
                                        <PaginationLink next />
                                    </PaginationItem>
                                    <PaginationItem hidden={this.state.totalPageP === 1} active={this.state.actualPage === this.state.totalPageP} onClick={() => { this.page(this.state.totalPageP); }}>
                                        <PaginationLink>
                                            {this.state.totalPageP}
                                        </PaginationLink>
                                    </PaginationItem>
                                </Pagination>
                            </Col>
                            <Col xs="1">
                                <Input className="col-md-6" style={{ width: '5vw' }} type="select" onChange={this.onChangeLimite} value={this.state.limite} >
                                    <option key={"sel-3"} selected={3 == this.state.limite} value={3}>{3}</option>
                                    <option key={"sel-6"} selected={6 == this.state.limite} value={6}>{6}</option>
                                    <option key={"sel-9"} selected={9 == this.state.limite} value={9}>{9}</option>
                                    <option key={"sel-12"} selected={12 == this.state.limite} value={12}>{12}</option>
                                </Input>
                            </Col>
                        </Row>
                        <div className="d-flex flex-row align-items-center col-9">
                            <h3>
                                <label style={{ color: '#918AD3' }} ></label>
                            </h3>
                        </div>{/* 918AD3 */}

                        <div className="d-flex flex-row py-4 align-items-center col-3">
                            {/*<Paginacion currentPage={currentPage} totalRecords={actividadesMutar.length} pageLimit={limite} pageNeighbours={vecindario} onPageChanged={this.onPageChanged} />*/}
                        </div>
                    </div>
                </div>
            </div>
            //<div>
            //    <Row>
            //        <Col xs="4">
            //            <label>
            //                Nombre/Apellido:
            //            </label>
            //            <Select name="nombre"
            //                options={nombresText}
            //                value={this.state.nombre}
            //                onChange={this.handleChangeNombre} />
            //        </Col>
            //        <Col xs="4">
            //            <label>
            //                Tipo:
            //            </label>
            //            <Select options={options}
            //                value={{ label: this.state.tipoSelect, value: this.state.filterTipo }}
            //                onChange={this.handleChangeTipo} />
                            
            //        </Col>
            //        <Col xs="4">
            //            {this.state.rol.includes('SUBDECANO') ?
            //            <>
            //            <label>
            //                Delegación:
            //            </label>
            //            <Select options={optionsDelegacion}
            //                value={{ label: this.state.delegacionSelect, value: this.state.filterDelegacion }}
            //                    onChange={this.handleChangeDelegacion} />
            //            </>
            //            : <></>}
            //        </Col>
            //    </Row>
            //    <div className="container mb-5">
            //        <div className="row d-flex flex-row">
            //        <div className="d-flex flex-row align-items-center col-9">
            //                <h3>
            //                    <label style={{ color: '#918AD3' }} ></label>
            //                </h3>
            //            </div>{/* 918AD3 */}
            //        <div className="d-flex flex-row py-3 align-items-right col-3">
            //                <Paginacion currentPage={currentPage} totalRecords={actividadesMutar.length} pageLimit={limite} pageNeighbours={vecindario} onPageChanged={this.onPageChanged} />                            
            //            </div>
            //            {/* <div className="w-100 px-4 d-flex flex-row flex-wrap align-items-center justify-content-between">

            //                <div className="d-flex flex-row align-items-center py-1">
            //                    <h3>
            //                        {this.state.filterTipo === 0 ? <label style={{ color: '#243165', fontWeight: 'bold'}} > Cargas a revisar </label>
            //                            : <label style={{ color: '#243165', fontWeight: 'bold' }} >Cargas {this.state.tipoSelect} </label>}

            //                    </h3>
            //                </div>

            //                <div className="d-flex flex-row py-4 align-items-center">
            //                    <Paginacion totalRecords={totalAct} pageLimit={limite} pageNeighbours={vecindario} onPageChanged={this.onPageChanged} />
            //                </div>

            //            </div> */}
            //            {currentActividades.map(act =>
            //                <div className="col-4 py-2">
            //                    <Card style={{ height: '100%' }} onClick={() => this.redirect(act.intIdPersona)}>
                                
            //                        <CardHeader style={{ backgroundColor: '#ECEFF3', display: 'flex' }}>
            //                            <Row>

            //                                <Col className='col-3 px-1'>
            //                                    <Image src={"https://talentohumano.espol.edu.ec/imgEmpleado/" + act.strCedula + ".jpg"}
            //                                        onError={(e) => (e.target.onerror = null, e.target.src = images['user2.png'].default)}
            //                                        style={{ width: 60, height: 60, borderRadius: '50%', overflow: 'hidden', borderWidth: 3, borderColor: 'red', }} />
            //                                </Col>

            //                                <Col className='col-9 px-2 py-2'>
            //                                    <Label style={{ justifyContent: 'center', fontSize: "1.9vh" }}><strong>{act.strNombreCompleto}</strong></Label>
            //                                </Col>

            //                            </Row>
            //                        </CardHeader>
            //                        <CardBody>
            //                            <CardText>Observaciones Totales: <strong>{act.cantAcciones + act.cantAccionesCoor}</strong></CardText>
            //                            <CardText>Observaciones Atendidas: <strong>{act.accionesIngresadas}</strong></CardText>
            //                            {/* <CardText>accionesPorIngresar: <strong>{act.accionesPorIngresar}</strong></CardText> */}
            //                            {this.state.rol.includes('SUBDECANO') ? <CardText>Observaciones Delegadas: <strong>{act.cantAccionesCoor}</strong></CardText> : <></>}
            //                            {this.state.rol.includes('SUBDECANO') ? <CardText>Delegaciones Atendidas: <strong>{act.accionesIngresadasCoor}</strong></CardText> : <></>}                                                                                
            //                        </CardBody>
            //                        <CardFooter>
            //                            <Row>
            //                                <Col className={"alola " + this.returnStatus(act)} >
            //                                    <CardText>Estado: <strong>{this.state.filterTipo === 0 ?
            //                                        act.accionesIngresadas + act.accionesIngresadasCoor === 0 ? "Pendiente" :
            //                                            act.accionesIngresadas + act.accionesIngresadasCoor == act.cantAcciones + act.cantAccionesCoor ? "Atendido" : "Parcialmente Atendido"
            //                                        : this.state.tipoSelect}</strong></CardText>
            //                                </Col>
            //                                <Col className="col-2">
            //                                    <Link
            //                                        to={`/profesor/${act.intIdPersona}`}
            //                                        key={act.intIdPersona}
            //                                    >
            //                                        <img src={images['edit.png'].default} alt="edit" width="30px" height="30px" className="iconEdit" />
            //                                    </Link>
            //                                </Col>
            //                            </Row>
            //                        </CardFooter>
                                    
            //                    </Card>
                                
            //                </div>
            //            )}

            //            <div className="d-flex flex-row align-items-center col-9">
            //                <h3>
            //                    <label style={{ color: '#918AD3' }} ></label>
            //                </h3>
            //            </div>{/* 918AD3 */}

            //            <div className="d-flex flex-row py-4 align-items-center col-3">
            //                <Paginacion currentPage={currentPage} totalRecords={actividadesMutar.length} pageLimit={limite} pageNeighbours={vecindario} onPageChanged={this.onPageChanged} />
            //            </div>
            //        </div>
            //    </div>
            //</div>
        );
    }

}

LoteCarga.propTypes = {
    carga: PropTypes.array.isRequired,
    rol: PropTypes.array.isRequired,
};

export default withRouter(LoteCarga);